<template>
  <Poptip
    trigger="hover"
    placement="bottom-end"
    :width="400"
    class="message-notify"
    @on-popper-show="changeTab"
  >
    <Badge :count="messages.unReadCount" class-name="badge">
      <span class="iconfont iconlingdang icon-message"></span>
    </Badge>
    <div slot="content" class="body">
      <Tabs v-model="tabValue" @on-click="changeTab">
        <TabPane :label="unReadLabel" :name="tabNames[0]">
          <List :loading="loading" class="list">
            <template v-if="messages.unReadCount > 0">
              <ListItem v-for="(msg, index) in messages.unReadMessages" :key="index" class="list-item">
                <ListItemMeta>
                  <div slot="avatar" class="avatar-unread"></div>
                  <span slot="title" class="title not-wrap">{{msg.msgTitle}}</span>
                  <Time slot="description" :time="msg.latelyPushTime" class="desc"></Time>
                </ListItemMeta>
                <template slot="action">
                  <li class="detail">
                    <a href="javascript:void(0)" class="a" @click="toDetail(msg.pushMsgId)">查看详情</a>
                  </li>
                </template>
              </ListItem>
            </template>
            <div v-else class="no-msg">
              <MissingPage type="noList">
                <div slot="message" class="no-msg-bg">
                  <p class="p">暂无未读消息</p>
                </div>
              </MissingPage>
            </div>
          </List>
          <div class="footer">
            <a href="javascript:void(0)" class="a" @click="toAll">查看全部消息</a>
          </div>
        </TabPane>
        <TabPane :label="readLabel" :name="tabNames[1]">
          <List :loading="loading" class="list">
            <template v-if="messages.readCount > 0">
              <ListItem v-for="(msg, index) in messages.readMessages" :key="index" class="list-item">
                <ListItemMeta>
                  <div slot="avatar" class="avatar-read"></div>
                  <span slot="title" class="title not-wrap">{{msg.msgTitle}}</span>
                  <Time slot="description" :time="msg.latelyPushTime" class="desc"></Time>
                </ListItemMeta>
                <template slot="action">
                  <li class="detail">
                    <a href="javascript:void(0)" class="a" @click="toDetail(msg.pushMsgId)">查看详情</a>
                  </li>
                </template>
              </ListItem>
            </template>
            <div v-else class="no-msg">
              <MissingPage type="noList">
                <div slot="message" class="no-msg-bg">
                  <p class="p">暂无已读消息</p>
                </div>
              </MissingPage>
            </div>
          </List>
          <div class="footer">
            <a href="javascript:void(0)" class="a" @click="toAll">查看全部消息</a>
          </div>
        </TabPane>
      </Tabs>
    </div>
  </Poptip>
</template>

<script>
  import api from '@/api'
  import eventBus from '../../libs/eventBus'
  import MissingPage from './missing-page'

  export default {
    name: 'message',
    components: { MissingPage },
    data () {
      return {
        messages: {
          unReadCount: 0,
          readCount: 0,
          unReadMessages: this.getDefaultMessages(),
          readMessages: this.getDefaultMessages()
        },
        tabNames: ['unRead', 'read'],
        tabValue: 'unRead',
        loading: false
      }
    },
    mounted () {
      this.changeTab()
    },
    methods: {
      getDefaultMessages () {
        return {
          msgId: '',
          msgTitle: '',
          msgContent: '',
          latelyPushTime: ''
        }
      },
      async getMessages () {
        return new Promise((resolve, reject) => {
          let endTime = Math.floor(Date.now() / 1000)
          let startTime = endTime - 7 * 24 * 3600
          let jsonParams = JSON.stringify({
            pageNum: 1,
            pageSize: 9999,
            startTime: startTime,
            endTime: endTime
          })
          api.messagenotify.listAll(jsonParams).then(response => {
            let result = response.data
            if (result.code === '0000') {
              let data = result.data
              this.messages = {
                unReadCount: data.unReadPushMsgCount,
                readCount: data.readPushMsgCount,
                unReadMessages: data.unReadPushMsgList,
                readMessages: data.readPushMsgList
              }
              resolve(this.messages)
            }
            reject(new Error('查询消息列表错误'))
          }).catch(err => {
            reject(new Error(err))
          }).finally(() => (this.loading = false))
        })
      },
      updateMessagesScrolling () {
        api.messagenotify.listScrolling('{}').then(response => {
          let result = response.data
          if (result.code === '0000') {
            this.$store.dispatch('setMessagesScrolling', result.data || [])
          }
        })
      },
      async changeTab () {
        await this.getMessages()
        this.updateMessagesScrolling()
      },
      toDetail (pushMsgId) {
        const isSame = this.$route.name === 'messagesAll'
        this.$router.push({name: 'messagesAll', query: {type: this.tabValue, pushMsgId}})
        isSame && eventBus.$emit('messages-all-init')
      },
      toAll () {
        const isSame = this.$route.name === 'messagesAll'
        this.$router.push({name: 'messagesAll', query: {type: this.tabValue}})
        isSame && eventBus.$emit('messages-all-init')
      }
    },
    computed: {
      unReadLabel () {
        return `未读消息(${this.messages.unReadCount})`
      },
      readLabel () {
        return `已读消息(${this.messages.readCount})`
      }
    },
    watch: {}
  }
</script>

<style lang="less">
  .message-notify {
    .badge {
      font-size: 14px;
      font-weight: 500;
      top: 0;
      right: 2px;
      height: 16px;
      line-height: 14px;
      min-width: 16px;
      padding: 0;
    }
    .ivu-poptip-body {
      padding: 0;
    }
    .ivu-tabs-bar {
      margin-bottom: 0;
      border-bottom: 1px solid #e8eaec;
      .ivu-tabs-nav-scroll {
        background: transparent;
        padding-left: 0;
        height: 44px;
        .ivu-tabs-nav {
          .ivu-tabs-ink-bar {
            display: none;
          }
          @hoverColor: fade(#009AFF, 80%);
          .ivu-tabs-tab {
            height: 44px;
            line-height: 30px;
            font-size: 16px;
            color: #999999;
            &:hover {
              color: @hoverColor;
            }
          }
          .ivu-tabs-tab-active {
            color: #009AFF;
            font-weight: 600;
            &:hover {
              color: @hoverColor;
              &:after {
                border: 1px solid @hoverColor;
              }
            }
            &:after {
              content: '';
              width: 50%;
              height: 0;
              border: 1px solid #009AFF;
              border-radius: 4px;
              position: absolute;
              bottom: 1px;
              left: 50%;
              transform: translateX(-50%);
              transition: all 1s ease;
            }
          }
        }
      }
    }
    .list {
      height: 350px;
      overflow-y: auto;
      padding: 0 16px;
      .ivu-list-item {
        padding: 15px 0;
        height: 70px;
        .ivu-list-item-meta-content {
          .ivu-list-item-meta-title {
            margin-bottom: 0;
          }
        }
        .ivu-list-item-action {
          align-self: flex-start;
          margin: -3px 4px 0 16px;
        }
      }
    }
  }
</style>

<style lang="less" scoped>

  .message-notify {
    .icon-message {
      color: #BBBBBB;
      font-size: 24px;
      &:hover {
        color: #009AFF;
      }
    }
    .body {
      .list {
        .list-item {
          .a {
            font-weight: 500;
          }
          .avatar-base() {
            margin-top: 3px;
            width: 40px;
            height: 40px;
          }
          .avatar-unread {
            .avatar-base;
            background: url("../../../static/images/icon_unread.svg") no-repeat;
            position: relative;
            &::after {
              content: '';
              position: absolute;
              width: 10px;
              height: 10px;
              top: 1px;
              right: 1px;
              border-radius: 100%;
              background: #ff3131;
              z-index: 10;
              box-shadow: 0 0 0 1px #FFFFFF;
            }
          }
          .avatar-read {
            .avatar-base;
            background: url("../../../static/images/icon_unread.svg") no-repeat;
          }
          .title {
            font-size: 16px;
            font-weight: 500;
            display: block;
            width: 225px;
            height: 23px;
          }
          .desc {
            font-size: 14px;
            font-weight: 500;
            color: #999999;
          }
          .detail {
            display: none;
          }
          &:hover {
            background-color: #F3F6F8;
            &:before {
              width: 16px;
              content: ' ';
              height: 70px;
              background-color: #F3F6F8;
              left: 0;
              position: absolute;
            }
            &:after {
              width: 16px;
              content: ' ';
              height: 70px;
              background-color: #F3F6F8;
              right: 0;
              position: absolute;
            }
            .detail {
              display: block;
            }
          }
        }
      }
      .no-msg {
        width: 100%;
        height: 200px;
        position: absolute;
        top: 50%;
        transform: translate(-16px, -50%);
        .no-msg-bg {
          width: 100%;
          height: 100%;
          display: flex;
          justify-content: center;
          align-items: flex-end;
          .p {
            font-size: 14px;
            font-weight: 500;
            color: #999999;
          }
        }
      }
    }
    .footer {
      width: 100%;
      height: 50px;
      border-top: 1px solid #e8eaec;
      text-align: center;
      line-height: 50px;
      .a {
        font-size: 16px;
        font-weight: 500;
        color: #333333;
        &:hover {
          opacity: 0.9;
        }
      }
    }
  }
</style>



// WEBPACK FOOTER //
// src/views/components/message.vue